export const REGISTER_PHOTO_LABELS: Record<string, string> = {
  T: 'Temperatura',
  R: 'Régua Frente',
  S: 'Régua Traseira',
  Q: 'Qualidade',
};

export const getRegisterPhotoLabel = (DFTIPOREGISTRO?: string) =>
  (DFTIPOREGISTRO && REGISTER_PHOTO_LABELS[DFTIPOREGISTRO]) || 'Ocorrência';
